import { Component, Input, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-modal',
  imports: [MatDialogModule],
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.scss'
})
export class DeleteModalComponent implements OnInit {
  @Input() data: any = {};

  ngOnInit(): void {
    console.log('data', this.data);
  }

  get name(){
    const p = this.data.payload;
    
    if(p.name) return p.name;
  
    if(p.suggestion) return p.suggestion;
    
    if(p.filename) return p.filename;

    if(p.firstName && p.lastName) return p.firstName + " " + p.lastName;

    if(p.label) return p.label;

    if(p.keyword && p.rQuery) return p.rQuery;

    if(p.keyword) return p.keyword;

    if(p.urlPattern) return p.urlPattern;

    if(p.url) return p.url;

    if(p.fieldName) return p.fieldName;

    if(p.aliasName) return p.aliasName;

    if(p.selectDay) return 'la schedulazione';

    else return 'questo elemento';
  }
}
